import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "mall-pack-mark__copy" }

import { computed } from 'vue'
import { formatOrderPackLabel, normalizeOrderStep } from '@/utils/mallSell'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallOrderPackMark',
  props: {
    orderStep: {},
    sellUnit: {},
    size: { default: 'inline' }
  },
  setup(__props: any) {

const props = __props

const packBase = computed(() => formatOrderPackLabel(normalizeOrderStep(props.orderStep), props.sellUnit))
const packLabel = computed(() =>
  props.size === 'detail' ? `${packBase.value}으로 주문할 수 있습니다` : packBase.value,
)
const ariaLabel = computed(() => `${packBase.value} · 낱개 주문 불가`)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mall-pack-mark", `mall-pack-mark--${__props.size}`]),
    "aria-label": ariaLabel.value
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", {
      class: "mall-pack-mark__bundle",
      "aria-hidden": "true"
    }, [
      _createElementVNode("span", { class: "mall-pack-mark__row" }, [
        _createElementVNode("i"),
        _createElementVNode("i"),
        _createElementVNode("i")
      ]),
      _createElementVNode("span", { class: "mall-pack-mark__row" }, [
        _createElementVNode("i"),
        _createElementVNode("i"),
        _createElementVNode("i")
      ])
    ], -1)),
    _createElementVNode("span", _hoisted_2, [
      _createElementVNode("strong", null, _toDisplayString(packLabel.value), 1),
      _cache[0] || (_cache[0] = _createElementVNode("em", null, "낱개 주문 불가", -1))
    ])
  ], 10, _hoisted_1))
}
}

})